angular.module('client_enrollment', ['ui.router','confirm.modal.html', 'ngResource', 'ngTable', 'ui.bootstrap']);

angular.module('client_enrollment').config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {

    $stateProvider
    .state('client_enrollment', {
        url         : "/client_enrollment",
        templateUrl : server+"/views/m/client_enrollment",
        controller  : 'client_enrollment.list',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'home',
            label: 'ClientContract'
        }
    })

    .state('client_enrollment_create', {
        url         : "/client_enrollment/create",
        templateUrl : server+"/views/m/client_enrollment/create",
        controller  : 'client_enrollment.create',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'client_enrollment',
            label: 'Adicionar'
        }
    })

    .state('client_enrollment_show', {
        url         : "/client_enrollment/:id",
        templateUrl : server+"/views/m/client_enrollment/show",
        controller  : 'client_enrollment.show',
        resolve     : {
            loginRequired: loginRequired
        },
        ncyBreadcrumb: {
            parent: 'client_enrollment',
            label: '{{client_enrollment.id}}'
        }
    })

}]);


/**
 * List Controller
 */
angular.module('client_enrollment').
controller('client_enrollment.list', ['$scope', '$http', '$auth', '$q', 'NgTableParams', '$client_enrollment', function($scope, $http, $auth, $q, NgTableParams, $client_enrollment) {
    $scope.tableParams = new NgTableParams({
        page: 1,
        count: 10
    }, {
        counts: [],
        filterDelay: 0,
        getData: function(params) {
            return $client_enrollment.query(params.url()).$promise.then(function(data) {
                params.total(data.total);
                return data.data;
            });
        }
    });
}]);

/**
 * Create Controller
 */
angular.module('client_enrollment').
controller('client_enrollment.create', ['$scope', '$rootScope', '$state', '$client_enrollment', function($scope, $rootScope, $state, $client_enrollment) {

    //dates definitions
    $scope.dates = {
      start_date: moment().startOf('month').toDate(),
      deadline: moment().endOf('month').toDate()
    }

    //open false in start_date
    $scope.start_date = {
        opened: false
    };

    //open false in start_date
    $scope.deadline = {
        opened: false
    };

    $scope.save = function() {
        $client_enrollment.save($scope.client_enrollment).$promise.then(function(data) {
            $state.go('client_enrollment_show', {
                id: data.id
            });
        });
    }
}]);

/**
 * Show, Edit, Delete Controller
 */
angular.module('client_enrollment').
controller('client_enrollment.show', ['$state', '$scope', '$stateParams', '$uibModal', '$client_enrollment', function($state, $scope, $stateParams, $uibModal, $client_enrollment) {

    $scope.editing = false;

    $scope.toggleEdit = function() {
        $scope.editing = !$scope.editing;
    }

    $client_enrollment.get({
        id: $stateParams.id
    }).$promise.then(function(data) {
        $scope.client_enrollment = data.client_enrollment;
    }, function(error) {
        if (error.status == 404) {
            $state.go('notFound');
        }
    });

    $scope.confirmUpdate = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$scope', '$uibModalInstance', '$client_enrollment', function($scope, $uibModalInstance, $client_enrollment) {

                $scope.title = 'Deseja atualizar?';
                $scope.cancel_text = 'Cancelar';
                $scope.success_text = 'Concluído';

                var client_enrollment = $scope.$parent.client_enrollment;

                $scope.confirm = function() {
                    $client_enrollment.update({
                        id: client_enrollment.id
                    }, client_enrollment).$promise.then(function(data) {
                        $uibModalInstance.dismiss('cancel');
                        $scope.$parent.toggleEdit();
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

    $scope.confirmDelete = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'confirm.modal.html',
            size: 'sm',
            scope: $scope,
            controller: ['$state', '$scope', '$uibModalInstance', '$client_enrollment', function($state, $scope, $uibModalInstance, $client_enrollment) {

                $scope.title = 'Deseja remover esse registro?';
                $scope.cancel_text = 'Não';
                $scope.success_text = 'Sim';

                var client_enrollment = $scope.$parent.client_enrollment;

                $scope.confirm = function() {
                    $client_enrollment.delete({id:client_enrollment.id}).$promise.then(function(data){
                        $uibModalInstance.dismiss('cancel');
                        $state.go('client_enrollment');
                    })
                }

                $scope.cancel = function() {
                    $uibModalInstance.dismiss('cancel');
                };

            }]
        });
    };

}]);


/**
 * Factory
 */
angular.module('client_enrollment').
factory("$client_enrollment", function($resource, $q, $http) {
    var resource = $resource(api + 'client_enrollment/:id', null, {
        'query': {
            method: 'GET',
            isArray: false
        },
        'update': {
            method: 'PUT'
        }
    });

    return resource;
});

angular.module("confirm.modal.html", []).run(["$templateCache", function($templateCache) {
    $templateCache.put('confirm.modal.html',
        '<div class="modal-body">' +
        ' {{title}}' +
        '</div>' +
        '<div class="modal-footer">' +
        '    <button class="btn btn-link btn-info" type="button" ng-click="cancel()">{{cancel_text}}</button>' +
        '    <button class="btn btn-outline btn-success" type="button" ng-click="confirm()">{{success_text}}</button>' +
        '</div>'
    );
}]);
